import { useMutation } from '@tanstack/react-query';
import { HttpService } from '@Services/api/httpService.ts';
import { useBoundStore } from '@Store/useBoundStore.ts';
import type { EddQuestion } from '@Store/slices/eddQuestions/createEddEmbeddedSlice';

interface Payload {
  version: string;
  results: EddQuestion[];
}

export const usePostEddData = () => {
  const { customerId } = useBoundStore((state) => state.customer);
  return useMutation({
    mutationFn: async (payload: Payload) => {
      const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
      return HttpService.post(
        isEmbedded
          ? `v4/secureonboarding/partner/user/${customerId}/edd`
          : `v4/secureonboarding/user/${customerId}/edd`,
        payload
      );
    },
    mutationKey: ['postEddData'],
  });
};
